"use strict";
/**
 * Replaces all the instances of '-' within a string with the unicode character for a non breaking hypen \u2011
 * @param {string}
 * @returns {string} string with all hyphens replaced
 */
Object.defineProperty(exports, "__esModule", { value: true });
const replaceHyphens = (stringValue) => stringValue.replace('-', '\u{2011}');
exports.default = replaceHyphens;
//# sourceMappingURL=replaceHyphens.js.map